/* @flow */
import userAgent from 'lib/currentUserAgent';

export default function openApp(path: ?string) {
  let location = `rmd:/${path || '/a'}`;
  if (userAgent.android()) {
    location =
      `intent:/${path || '/a'}#Intent;scheme=rmd;package=com.remind101;` +
      `S.browser_fallback_url=${encodeURI(window.location.href)};end`;
  }
  window.location = location;
}
